module.exports = __webpack_public_path__ + "img/github.logo.a9f7ad3d.svg";